import React, { useState } from "react";
import useDBO from "../../../hooks/useDBO";
import Loading from "../../../components/Loading";
import Error from "../../../components/Error";
import Lang from "../../../components/Lang";
import VND from "../../../components/VND";
import Loca from "../../../components/Loca";
import Staff from "../../../components/Staff";
import { format } from "date-fns";
import AddButton from "../../../components/AddButton";
import WithdrawDialog from "./WithdrawDialog";

/**
 * CashWithdrawals component.
 * Displays a table of cash withdrawal records with add functionality.
 * Uses flat premium design language with Tailwind utilities.
 *
 * @param {Object} props - Component props
 * @param {Object} props.date - Current date filter
 * @returns {JSX.Element} Cash withdrawals section with table and add dialog
 * @author Forge
 * @date 2026-04-08
 * @version 2.0
 */
export default function CashWithdrawals({date}) {


const withdrawals = useDBO(`/cashwithdrawals?tDate=${date}`)
    
const [open, setOpen] = useState(false);


if (withdrawals.loading) return <Loading />;
if (withdrawals.error) return <Error />;


    return (
      <div className="border border-slate-200 rounded-[10px] overflow-hidden">
        <div className="money-subtitle mx-4 mt-3">
          <div>
            <Lang w="cashWithdrawals" />
          </div>
          <AddButton
            tooltip={<Lang w="withdrawCashToTheOwner" />}
            action={() => setOpen(true)}
          />
        </div>
        <div className="px-4 pb-3">
        <table className="withdraw-table">
          <thead>
            <tr>
              <th>
                <Lang w="amount" />
              </th>
              <th>
                <Lang w="float" />
              </th>
              <th>
                <Lang w="location" />
              </th>
              <th>
                <Lang w="cashier" />
              </th>
              <th>
                <Lang w="time" />
              </th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map((w) => (
              <tr key={w._id}>
                <td>
                  <VND value={w.amount} />
                </td>
                <td>
                  <VND value={w.float} />
                </td>
                <td>
                  <Loca id={w.location} />
                </td>
                <td>
                  <Staff id={w.cashier} />
                </td>
                <td>
                  {format(new Date(w.createdAt), "h:mm aaa")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <WithdrawDialog
          open={open}
          setOpen={setOpen}
          withdrawals={withdrawals}
        />
      </div>
    );
}